import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Dialog, DialogTitle, Grid } from "@mui/material";
import FormField from "../../../../components/form-controls/form-field";
import theme from "../../../../app/app-theme";
import FormCloseButton from "../../../../components/form-controls/form-close-button";
import { FormTextField } from "../../../../components/form-input-field-wrappers/form-controller-inputs/form-text-field";
import { Exercise, ExerciseRequest } from "../../../../service/model/workout.model";
import { FormSelectField } from "../../../../components/form-input-field-wrappers/form-controller-inputs/form-select-field";

interface ExerciseFormProps {
    readonly exercise?: Exercise
    readonly editable: boolean
    readonly onClose: () => void
    readonly onSubmit: (data: ExerciseRequest) => void
}

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 400,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

const ExerciseForm: React.FC<ExerciseFormProps> = ({ exercise, editable, onClose, onSubmit }) => {
    const schema = yup.object().shape({
        name: yup.string()
            .required(),
        muscleGroup: yup.string(),
        equipment: yup.string(),
        description: yup.string(),
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmitHandler = (data: any) => {
        onSubmit(data as ExerciseRequest)
    };

    return (
        <Dialog open={true} onClose={onClose} sx={style}>
            <DialogTitle>Exercise Details</DialogTitle>
            <Box sx={style}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <form onSubmit={handleSubmit(onSubmitHandler)}>
                        <FormField>
                            <FormTextField
                                id="exercise-name"
                                label="Exercise Name"
                                name="name"
                                variant="outlined"
                                defaultValue={exercise?.name}
                                errorMessage={errors.name?.message}
                                register={register}
                            />
                        </FormField>
                        <FormField>
                            <FormSelectField
                                id={"muscle-group"}
                                label="Muscle Group"
                                name="muscleGroup"
                                defaultValue={exercise?.muscleGroup}
                                errorMessage={errors.muscleGroup?.message}
                                options={
                                    [
                                        { label: 'Back', value: 'back' },
                                        { label: 'Biceps', value: 'biceps' },
                                        { label: 'Cardio', value: 'cardio' },
                                        { label: 'Chest', value: 'chest' },
                                        { label: 'Core', value: 'core' },
                                        { label: 'Forearms', value: 'forearms' },
                                        { label: 'Full Body', value: 'full_body' },
                                        { label: 'Legs', value: 'legs' },
                                        { label: 'Shoulders', value: 'shoulders' },
                                        { label: 'Triceps', value: 'triceps' },
                                        { label: 'Other', value: 'other' },
                                    ]
                                }
                                register={register}
                            />
                        </FormField>
                        {/* <FormField>
                            <FormSelectField
                                id={"equipment"}
                                label="Equipment"
                                name="equipment"
                                defaultValue={exercise?.equipment}
                                errorMessage={errors.equipment?.message}
                                options={
                                    [
                                        { label: 'Barbell', value: 'barbell' },
                                        { label: 'Bodyweight', value: 'bodyweight' },
                                        { label: 'Cable', value: 'cable' },
                                        { label: 'Dumbbell', value: 'dumbbell' },
                                        { label: 'EZ Bar', value: 'ez_bar' },
                                        { label: 'Kettlebell', value: 'kettlebell' },
                                        { label: 'Machine', value: 'machine' },
                                        { label: 'Medicine Ball', value: 'medicine_ball' },
                                        { label: 'Resistance Band', value: 'resistance_band' },
                                        { label: 'Smith Machine', value: 'smith_machine' },
                                        { label: 'Suspension Trainer', value: 'suspension_trainer' },
                                        { label: 'Other', value: 'other' },
                                    ]
                                }
                                register={register}
                            />
                        </FormField> */}
                        <FormField>
                            <FormTextField
                                id="exercise-description"
                                label="Description"
                                name="description"
                                variant="outlined"
                                defaultValue={exercise?.description}
                                errorMessage={errors.description?.message}
                                register={register}
                            />
                        </FormField>
                        <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                            <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                            <Button type="submit" variant="contained" >Submit</Button>
                        </Grid>
                    </form>
                </>
            </Box>
        </Dialog>
    );
}

export default ExerciseForm;